import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import history from '../../history';
import "./BackLink.css";

export default class HistoryBackLink extends Component {
    render(){
        return (
            <div className="back-link" onClick={() => history.goBack()}>
                <FontAwesomeIcon icon="chevron-left" className="back-icon" size="xs" />
                <span>{this.props.directionName}</span>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/BackLink/HistoryBackLink.js